import React from 'react';

import { Loader } from '../../components/loader/Loader';

const AdminLayout = React.lazy(() =>
  import(/* webpackChunkName: "admin-layout" */ './AdminLayout.container'),
);

export default (props: any) => (
  <React.Suspense fallback={<Loader />}>
    <AdminLayout {...props} />
  </React.Suspense>
);
